/**
 * SkipLink - דלג לתוכן הראשי
 * First focusable element on the page. Visually hidden until focused (Tailwind
 * sr-only + focus:not-sr-only), then jumps keyboard users straight to the main
 * content region (#main-content). WCAG 2.4.1 Bypass Blocks.
 */

export default function SkipLink() {
  return (
    <a
      href="#main-content"
      className="skip-link sr-only focus:not-sr-only focus:fixed focus:px-4 focus:py-2 focus:bg-primary-600 focus:text-white focus:rounded-lg focus:shadow-lg"
    >
      דלג לתוכן הראשי
    </a>
  )
}
